
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-theme-locale.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-plugin-theme-locale-demo-locale","docs-x-markdown-plugin-theme-locale-demo-theme"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-theme-locale.zh-CN.md?type=demo')
};